import React from "react";
import { OcRoleFilterView } from "./role-filter-view";
import { OcRoleFilterProps } from "./role-filter.types";
// There are multiple useOcRoleFilter hooks!
import { useOcRoleFilter } from "./use-role-filter";

/**
 * Either noFilters must be true, or subtypeProps must be given.
 */
export const OcRoleFilter: React.FC<OcRoleFilterProps> = ({
  buttonBarProps,
  innerWidth,
  defaultOpened = false,
  ...props
}) => {
  const extraProps = useOcRoleFilter({
    buttonBarProps,
    defaultOpened,
    innerWidth,
    noFilters: props.noFilters,
  });

  return (
    <OcRoleFilterView
      {...extraProps}
      {...props}
      buttonBarProps={buttonBarProps}
    />
  );
};
